import keyMirror from 'keymirror';

const LANGUAGE_CODES = keyMirror({
  en: null,
  es: null,
  fr: null,
  it: null,
  pt: null,
});

export default LANGUAGE_CODES;
